exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-dropdown .ui-dropdown-clear-icon{right:2.6em}", ""]);

// exports
